import React, { useContext, useEffect, useState } from 'react'
import Filter from '../../Components/Catalog/Filter/Filter'
import Table from '../../Components/Catalog/Table/Table';
import PageHeader from '../../Components/Layout/PageHeader/PageHeader';
import CloseIcon from '../../Assets/Images/CloseIcon.svg';
import { CatalogContext } from '../../Context/CatalogContext';

export default function Catalog() {

  const { 
    handleCheckboxChange,
    checkboxStates,
    totalCount,
    filteredData,
    setFilteredData,
    dataFilters,
    filters,
    clearFilters,
    gender,
    setGender,
    setFilteredMaxAge,
    setFilteredMinAge,
    filteredMinAge,
    filteredMaxAge,
    removeFilter,
  } = useContext(CatalogContext);

  const [filterBoxOpened, setFilterBoxOpened] = useState(false);

  useEffect(() => {
    clearFilters();
  }, [])


  function handleClose() {
    setFilterBoxOpened(false);
  }
  function handleOpen() {
    setFilterBoxOpened(true);
  }

  return (
    <>
      <PageHeader currentPage={"Custom"} />
      <div className='catalog'>
        <Filter onClose={handleClose} handleOpen={handleOpen} filterBoxOpened={filterBoxOpened} handleCheckboxChange={handleCheckboxChange} checkboxStates={checkboxStates} total={totalCount} count={filteredData?.length || 0} dataFilters={dataFilters} filtersApplied={filters.length} clearFilters={clearFilters} gender={gender} setGender={setGender} setFilteredMaxAge={setFilteredMaxAge} setFilteredMinAge={setFilteredMinAge} filteredMinAge={filteredMinAge} filteredMaxAge={filteredMaxAge} />
        <div className='catalog-right'>
          <div className='catalog-content'>
            {filters.length > 0 && <div className='filters-container'>
              {filters.map((filter, index) =>
                <div className='filter' key={index}>
                  <p>{filter}</p>
                  <img src={CloseIcon} alt="close icon" width={12} height={12} onClick={() => removeFilter(filter)} />
                </div>
              )}
            </div>}
            <Table data={filteredData} />
          </div>
        </div>
      </div>
    </>
  )
}
